/**
 * FORGE-164: detect MCP servers that authenticate against an AWS ACCOUNT.
 *
 * Such a server MUST assume the CLIENT's role — running it against Forge's task
 * role reads the wrong (Forge's) account, which is never what a client wants. So
 * for these the cross-account role is REQUIRED, not optional. Mirror of the
 * agent's heuristic in agent/lib/mcpAwsCreds.js.
 *
 * Heuristic: a stdio server whose command/args reference an `awslabs.*` MCP
 * server, EXCEPT `aws-documentation` (public docs, no creds). Custom servers opt
 * in explicitly by setting any `aws_*` field.
 */
import type { McpServer } from '../types/projects';

export function serverNeedsAwsAccount(s: Partial<McpServer> | null | undefined): boolean {
  if (!s) return false;
  if (s.aws_assume_role_arn || s.aws_region || s.aws_external_id) return true;
  if (s.transport && s.transport !== 'stdio') return false;
  const hay = `${s.command ?? ''} ${(s.args ?? []).join(' ')}`.toLowerCase();
  if (hay.includes('aws-documentation')) return false;
  return /awslabs\./.test(hay);
}
